// extracted by mini-css-extract-plugin
module.exports = {"Hr":"Auth_Hr__1cRG4","body":"Auth_body__3EuqG","LogIn":"Auth_LogIn__3B3CI","Hr2":"Auth_Hr2__1tIg-","Hr3":"Auth_Hr3__2MaGx","textBox":"Auth_textBox__bkCCS"};